import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'colorType',
})<{ colorType?: 'orange' | 'gray' }>(({ colorType }) => {
  const orange700 = '#f17f16';
  const orange100 = 'rgba(241, 127, 22, 0.1)';
  const neutralsDark12 = '#003e4712';
  const neutralsSolid6 = '#b2c5c8';

  return {
    borderRadius: '4px',
    display: 'flex',
    padding: '12px 16px',
    alignItems: 'center',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',

    ...(colorType === 'orange' && {
      borderColor: orange700,
      background: orange100,
      color: orange700,
    }),

    ...(colorType === 'gray' && {
      background: neutralsDark12,
      border: `1px solid ${neutralsSolid6}`,
      color: 'rgba(0, 62, 71, 0.6)', // Approximation of neutrals-solid-dark-40
    }),
  };
});
